import type { ReportsMessageId } from "./reports.fr";

/** Signalements in German. Same keys and {placeholders} as reports.fr.ts. */
export const reportsDe: Record<ReportsMessageId, string> = {
  "reports.filter.severity": "Schweregrad",
  "reports.filter.status": "Status",
  "reports.filter.all": "Alle",
  "reports.filter.reviewOverdue": "Sperrprüfung überfällig",
  "reports.list.loading": "Meldungen werden geladen…",
  "reports.list.loadFailed": "Die Meldungen konnten nicht geladen werden.",
  "reports.list.empty": "Keine Meldungen für diese Filter.",
  "reports.list.aria": "Meldungen",
  "reports.list.by": "gemeldet von {name}",
  "reports.list.aboutSubject": "{count} Meldungen zu dieser Person",
  "reports.pick": "Wählen Sie eine Meldung aus der Liste.",
  "reports.loading": "Meldung wird geladen…",
  "reports.loadFailed": "Diese Meldung konnte nicht geladen werden.",
  "reports.notFound": "Diese Meldung wurde nicht gefunden. Laden Sie die Liste neu.",
  "reports.refreshFailed": "Die Meldung konnte nicht aktualisiert werden: Sie wird im vorherigen Stand angezeigt.",
  "reports.dismiss": "Schließen",

  "reports.severity.critical": "Kritisch",
  "reports.severity.high": "Hoch",
  "reports.severity.medium": "Mittel",
  "reports.severity.low": "Niedrig",
  "reports.status.open": "Offen",
  "reports.status.investigating": "In Prüfung",
  "reports.status.decided": "Entschieden",
  "reports.status.appealed": "Im Einspruch",
  "reports.status.closed": "Abgeschlossen",
  "reports.verdict.none": "Keine Sanktion",
  "reports.verdict.warning": "Verwarnung",
  "reports.verdict.temporary_suspension": "Befristete Sperre",
  "reports.verdict.permanent_ban": "Dauerhafter Ausschluss",
  "reports.appeal.upheld": "Entscheidung bestätigt",
  "reports.appeal.overturned": "Entscheidung aufgehoben",
  "reports.source.app": "Aus der App",
  "reports.source.phone": "Per Telefon",
  "reports.source.console": "Vom Team eröffnet",

  "reports.category.assault": "Körperverletzung",

  "reports.new.title": "Neue Meldung",

  "reports.new.source": "Wie sie uns erreicht hat",

  "reports.new.byPhone": "Telefonisch",

  "reports.new.byStaff": "Vom Team bemerkt",

  "reports.new.subject": "Wer gemeldet wird",

  "reports.new.reporter": "Wer gemeldet hat",

  "reports.new.reporterHint":
    "Ihre Benutzer-ID, wenn ein Kunde gemeldet hat. Leer lassen, wenn das Team es bemerkt hat.",

  "reports.new.category": "Was passiert ist",

  "reports.new.categoryHint": "Die Schwere ergibt sich daraus. Später änderbar.",

  "reports.new.description": "Was uns gesagt wurde",

  "reports.new.descriptionHint": "Möglichst in ihren Worten. Das liest, wer den Fall untersucht.",

  "reports.new.submit": "Meldung eröffnen",

  "reports.new.needSubject": "Wählen Sie, wer gemeldet wird.",

  "reports.new.needDescription": "Beschreiben Sie, was passiert ist, mindestens in einem Satz.",

  "reports.new": "Neue Meldung",
  "reports.category.sexual_violence": "Sexuelle Gewalt",
  "reports.category.serious_theft": "Schwerer Diebstahl",
  "reports.category.weapon_threat": "Bedrohung mit einer Waffe",
  "reports.category.theft": "Diebstahl",
  "reports.category.threats": "Drohungen",
  "reports.category.harassment": "Belästigung",
  "reports.category.fraud": "Betrug",
  "reports.category.unsafe_work": "Gefährliche Arbeit",
  "reports.category.no_show": "Termin nicht wahrgenommen",
  "reports.category.other": "Sonstiges",

  "reports.pill.suspended": "Gesperrt",
  "reports.pill.reviewOverdue": "Prüfung überfällig",
  "reports.pill.legalHold": "Legal Hold",

  "reports.detail.versionTitle": "Die angezeigte Version der Meldung: Jede Aktion sendet sie mit.",
  "reports.detail.critical": "Kritische Meldung",
  "reports.detail.needsPolice": "Sie wurde noch nicht an die Polizei übergeben. Die Inhaber wurden benachrichtigt.",
  "reports.detail.subject": "Gemeldete Person",
  "reports.detail.reporter": "Meldende Person",
  "reports.detail.openedBy": "Eröffnet von {name}",
  "reports.detail.noReporter": "Unbekannt",
  "reports.detail.job": "Zugehörige Anfrage",
  "reports.detail.case": "Ursprünglicher Fall",
  "reports.detail.subjectCase": "Fall der gemeldeten Person",
  "reports.detail.openCase": "Fall öffnen →",
  "reports.detail.noSubjectCase": "Keiner: Er wird bei Sperre oder Einspruch eröffnet",
  "reports.detail.none": "Keine",
  "reports.detail.description": "Was passiert ist",
  "reports.detail.restrictions": "Sperren und Ausschlüsse",
  "reports.detail.restrictionsHint":
    "Eine Sperre gilt bis zu einer Entscheidung des Teams. Die Prüffrist ist kein Ende: Nach Ablauf bleibt die Person gesperrt und die Prüfung ist überfällig.",
  "reports.detail.verdict": "Urteil",
  "reports.detail.decidedBy": "Von {name}, am {date}",
  "reports.detail.appeal": "Einspruch",
  "reports.detail.appealedAt": "Einspruch eingegangen am {date}",
  "reports.detail.appealPending": "Zu entscheiden",
  "reports.detail.police": "Übergaben an die Polizei",
  "reports.detail.shared": "Übergebene Daten: {categories} · {name}, {date}",
  "reports.detail.holds": "Legal Holds",
  "reports.detail.holdPlaced": "Aktiv seit {date} · {name}",
  "reports.detail.holdReleased": "Aufgehoben am {date} · {name}",
  "reports.detail.related": "Weitere Meldungen zu dieser Person",
  "reports.detail.timeline": "Verlauf",
  "reports.detail.actions": "Aktionen",
  "reports.detail.noActions": "Ihre Rollen erlauben keine Aktion für diese Meldung.",

  "reports.restriction.interim_suspension": "Sperre während der Prüfung",
  "reports.restriction.temporary_suspension": "Befristete Sperre",
  "reports.restriction.permanent_ban": "Dauerhafter Ausschluss",
  "reports.restriction.untilDecision": "Bis zur Entscheidung des Teams",
  "reports.restriction.untilDecisionReviewBy": "Bis zur Entscheidung des Teams · zu prüfen bis {date}",
  "reports.restriction.until": "Bis {date}",
  "reports.restriction.permanent": "Dauerhaft, außer bei erfolgreichem Einspruch",
  "reports.restriction.switchedOff": "Abgeschaltet: {features}",
  "reports.restriction.lifted": "Aufgehoben am {date} von {name}",
  "reports.restriction.inForce": "In Kraft",
  "reports.restriction.ended": "Beendet",

  "reports.entry.report": "Meldung",
  "reports.entry.evidence": "Beweis",
  "reports.entry.severity_changed": "Schweregrad geändert",
  "reports.entry.suspended": "Sperre",
  "reports.entry.suspension_lifted": "Sperre aufgehoben",
  "reports.entry.verdict": "Urteil",
  "reports.entry.appeal": "Einspruch",
  "reports.entry.appeal_decided": "Einspruch entschieden",
  "reports.entry.police_referral": "An die Polizei übergeben",
  "reports.entry.police_data_shared": "Daten an die Polizei übergeben",
  "reports.entry.legal_hold_placed": "Legal Hold gesetzt",
  "reports.entry.legal_hold_released": "Legal Hold aufgehoben",
  "reports.entry.linked": "Verknüpfung hinzugefügt",
  "reports.entry.suspension_withheld": "Sperre nicht angewendet",
  "reports.entry.system": "System",
  "reports.entry.evidenceLink": "Beweis ansehen →",

  "reports.police.category.identity": "Identität",
  "reports.police.category.contact_details": "Kontaktdaten",
  "reports.police.category.id_document": "Ausweisdokument",
  "reports.police.category.messages": "Nachrichten",
  "reports.police.category.job_details": "Details der Anfrage",
  "reports.police.category.report_and_evidence": "Meldung und Beweise",
  "reports.police.category.audit_log": "Audit-Protokoll",
  "reports.police.category.payments": "Zahlungen",
  "reports.hold.entity.safety_report": "Diese Meldung",
  "reports.hold.entity.user": "Das Konto",
  "reports.hold.entity.job": "Die Anfrage",
  "reports.hold.entity.conversation": "Die Unterhaltung",

  "reports.block.ownVerdict": "Sie haben das Urteil gefällt: Jemand anderes muss über den Einspruch entscheiden.",
  "reports.block.ownerOnly": "Nur ein Inhaber kann Daten an die Polizei übergeben.",
  "reports.block.noReferral": "Übergeben Sie die Meldung zuerst an die Polizei, um übergebene Daten zu erfassen.",

  "reports.action.evidence": "Beweis hinzufügen",
  "reports.action.severity": "Schweregrad ändern",
  "reports.action.suspend": "Während der Prüfung sperren",
  "reports.action.lift": "Sperre aufheben",
  "reports.action.verdict": "Urteil fällen",
  "reports.action.ban": "Dauerhaft ausschließen",
  "reports.action.appeal": "Über Einspruch entscheiden",
  "reports.action.police": "An die Polizei übergeben",
  "reports.action.share": "Übergebene Daten erfassen",
  "reports.action.hold": "Legal Hold setzen",
  "reports.action.release": "Legal Hold aufheben",

  "reports.dialog.evidence.title": "Beweis hinzufügen · {reference}",
  "reports.dialog.evidence.body":
    "Beschreiben Sie den Beweis und geben Sie den Link an, falls er online ist. Er wird in den Verlauf aufgenommen.",
  "reports.dialog.severity.title": "Schweregrad ändern · {reference}",
  "reports.dialog.severity.body":
    "Eine kritische Meldung benachrichtigt die Inhaber und muss an die Polizei übergeben werden. Sagen Sie, warum Sie ihn ändern.",
  "reports.dialog.suspend.title": "Sperren · {reference}",
  "reports.dialog.suspend.body":
    "{name} kann Walliyo nicht mehr nutzen, außer um das Team zu kontaktieren und Einspruch einzulegen, bis zu einer Entscheidung des Teams. Es gilt eine Prüffrist: Sie ist kein Ende der Sperre. Die Person wird in der App benachrichtigt, und ein Fall wird auf ihren Namen eröffnet.",
  "reports.dialog.lift.title": "Sperre aufheben · {reference}",
  "reports.dialog.lift.body": "{name} erhält ab sofort wieder Zugang zu Walliyo. Sagen Sie, warum.",
  "reports.dialog.verdict.title": "Urteil fällen · {reference}",
  "reports.dialog.verdict.body":
    "{name} liest die Begründung in der App und kann einmal Einspruch einlegen. Niemand wird ohne schriftliche Begründung sanktioniert.",
  "reports.dialog.ban.title": "Dauerhaft ausschließen · {reference}",
  "reports.dialog.ban.body":
    "{name} verliert endgültig den Zugang zu Walliyo, und das Ausweisdokument wird gesperrt. Die Begründung wird in der App angezeigt; ein einmaliger Einspruch ist möglich.",
  "reports.dialog.appeal.title": "Über Einspruch entscheiden · {reference}",
  "reports.dialog.appeal.body":
    "Aufgehoben macht rückgängig, was das Urteil eingeführt hat. {name} liest Ihre Begründung in der App. Jemand anderes als die Person, die das Urteil gefällt hat, muss entscheiden.",
  "reports.dialog.police.title": "An die Polizei übergeben · {reference}",
  "reports.dialog.police.body": "Erfassen Sie, an wen die Meldung übergeben wurde. Von hier wird nichts gesendet.",
  "reports.dialog.share.title": "An die Polizei übergebene Daten · {reference}",
  "reports.dialog.share.body":
    "Erfassen Sie genau, was übergeben wurde, Kategorie für Kategorie. Dieser Nachweis wird aufbewahrt und erscheint im Audit-Protokoll.",
  "reports.dialog.hold.title": "Legal Hold setzen · {reference}",
  "reports.dialog.hold.body":
    "Solange der Legal Hold besteht, kann nichts zu dieser Meldung gelöscht werden, auch nicht durch die Aufbewahrungsregel.",
  "reports.dialog.release.title": "Legal Hold aufheben · {reference}",
  "reports.dialog.release.body": "Die Aufbewahrungsregeln gelten wieder für alles, was der Legal Hold geschützt hat.",

  "reports.field.evidence": "Der Beweis",
  "reports.field.evidenceUrl": "Link (optional)",
  "reports.field.evidenceUrlHint": "Eine https://-Adresse, zum Beispiel ein im Fall hochgeladenes Foto.",
  "reports.field.severity": "Neuer Schweregrad",
  "reports.field.verdict": "Urteil",
  "reports.field.suspendedUntil": "Gesperrt bis",
  "reports.field.toldReason": "Begründung für die Person",
  "reports.field.toldHint": "Ein echter Satz, in Worten, die die Person versteht. Mindestens 10 Zeichen.",
  "reports.field.decision": "Entscheidung",
  "reports.field.station": "Polizeiwache oder Dienststelle",
  "reports.field.officerName": "Name des Beamten",
  "reports.field.officerContact": "Kontakt des Beamten (optional)",
  "reports.field.policeReference": "Aktenzeichen der Polizei (optional)",
  "reports.field.referral": "Übergabe",
  "reports.field.categories": "Übergebene Daten",
  "reports.field.shareDescription": "Was genau übergeben wurde",
  "reports.field.shareDescriptionHint": "Zum Beispiel: Nachrichten vom 3. bis 5. Mai, Scan des Personalausweises.",
  "reports.field.reasonOptional": "Begründung (optional)",

  "reports.problem.reason": "Geben Sie eine Begründung mit {min} bis {max} Zeichen an.",
  "reports.problem.told": "Schreiben Sie die Begründung für die Person: mindestens {min} Zeichen.",
  "reports.problem.evidence": "Beschreiben Sie den Beweis.",
  "reports.problem.url": "Der Link muss eine vollständige http://- oder https://-Adresse sein.",
  "reports.problem.until": "Wählen Sie ein Enddatum der Sperre in der Zukunft.",
  "reports.problem.police": "Geben Sie die Polizeiwache und den Namen des Beamten an (je 2 bis 200 Zeichen).",
  "reports.problem.referral": "Wählen Sie die betreffende Übergabe.",
  "reports.problem.categories": "Wählen Sie mindestens eine Kategorie übergebener Daten.",
  "reports.problem.shareDescription": "Geben Sie genau an, was übergeben wurde.",

  "reports.done.evidence": "Beweis zu {reference} hinzugefügt.",
  "reports.done.severity": "Schweregrad von {reference} geändert.",
  "reports.done.suspend":
    "Person gesperrt bis zur Entscheidung des Teams ({reference}). Sie wurde in der App benachrichtigt.",
  "reports.done.lift": "Sperre aufgehoben ({reference}).",
  "reports.done.verdict": "Urteil zu {reference} gespeichert. Die Person wurde in der App benachrichtigt.",
  "reports.done.ban": "Ausschluss zu {reference} gespeichert. Die Person wurde in der App benachrichtigt.",
  "reports.done.appeal": "Einspruch zu {reference} entschieden. Die Person wurde in der App benachrichtigt.",
  "reports.done.police": "Übergabe an die Polizei zu {reference} erfasst.",
  "reports.done.share": "Übergebene Daten zu {reference} erfasst.",
  "reports.done.hold": "Legal Hold für {reference} gesetzt.",
  "reports.done.release": "Legal Hold für {reference} aufgehoben.",

  "reports.error.stale":
    "Diese Meldung hat sich geändert, während Sie sie angesehen haben. Laden Sie sie neu, prüfen Sie und versuchen Sie es erneut.",
  "reports.error.refused":
    "Aktion abgelehnt: Ihre Rollen enthalten die nötige Funktion nicht. Bitten Sie eine verantwortliche Person um Zugang.",
  "reports.error.appealRefused":
    "Abgelehnt: Über den Einspruch muss jemand anderes als die Person entscheiden, die das Urteil gefällt hat, mit HANDLE_APPEALS.",
  "reports.error.shareRefused": "Abgelehnt: Nur ein Inhaber kann Daten an die Polizei übergeben.",
  "reports.error.invalid":
    "Abgelehnt: Die Meldung ist nicht mehr im erwarteten Zustand, oder ein Feld ist ungültig. Laden Sie sie neu und prüfen Sie.",
  "reports.error.outcomeUnknown":
    "Keine Antwort vom Server: Die Aktion wurde möglicherweise gespeichert. Versuchen Sie es erneut: Derselbe Klick kann nicht zweimal angewendet werden.",

  "reports.refused.wrongStatus":
    "Abgelehnt: Diese Meldung ist nicht mehr in diesem Schritt, die Aktion gilt nicht mehr. Laden Sie sie neu.",
  "reports.refused.alreadyRestricted": "Abgelehnt: Diese Person ist bereits durch eine andere Meldung gesperrt.",
  "reports.refused.notSuspended": "Abgelehnt: Diese Meldung hat keine laufende Sperre mehr. Laden Sie sie neu.",
  "reports.refused.suspendedUntilRequired": "Eine vorübergehende Sperre braucht ein Enddatum in der Zukunft.",
  "reports.refused.ownVerdict":
    "Abgelehnt: Sie haben dieses Urteil gefällt, also muss jemand anderes über den Einspruch entscheiden.",
  "reports.refused.alreadyHeld": "Für diese Meldung ist bereits ein Legal Hold gesetzt. Laden Sie sie neu.",
  "reports.refused.notHeld": "Für diese Meldung ist kein Legal Hold mehr gesetzt. Laden Sie sie neu.",
};
